import Cookies from 'js-cookie'

export const setCookie = ({ name, value, expiredAt }) => {
  const config = {
    // secure: true,
    domain: window.location.hostname,
    sameSite: 'lax'
  }

  if (expiredAt) {
    config.expires = new Date(expiredAt)
  }

  Cookies.set(name, value, config)
}

export const removeCookie = (name) => {
  const config = {
    domain: window.location.hostname
  }
  Cookies.remove(name, config)
}

export const getCookie = (name) => {
  return Cookies.get(name)
}
